module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgzMiA3MDR2MTkyYTMyIDMyIDAgMCAxLTMyIDMySDIyNGEzMiAzMiAwIDAgMS0zMi0zMnYtMTkyaDY0MHogbS01MTIgODBhMzIgMzIgMCAxIDAgMCA2NCAzMiAzMiAwIDAgMCAwLTY0ek04MzIgMzg0djI1NkgxOTJ2LTI1Nmg2NDB6IG0tNTEyIDk2YTMyIDMyIDAgMSAwIDAgNjQgMzIgMzIgMCAwIDAgMC02NHpNODAwIDk2YTMyIDMyIDAgMCAxIDMyIDMydjE5MkgxOTJWMTI4YTMyIDMyIDAgMCAxIDMyLTMyaDU3NnpNMzIwIDE3NmEzMiAzMiAwIDEgMCAwIDY0IDMyIDMyIDAgMCAwIDAtNjR6IiBmaWxsPSIjMCIgcC1pZD0iNDczNCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Database-filled.svg
// module id = dghl
// module chunks = 75